<div class="fab-container">
  <button mat-fab class="fab-toggler" (click)="onToggleFab()">
    <i class="material-icons" [@fabToggler]="{value: fabTogglerState}">add</i> <!-- Animation here -->
  </button>
  <div [@speedDialStagger]="buttons.length"> <!-- and here -->
    <button *ngFor="let btn of buttons" mat-mini-fab class="fab-secondary" [color]="btn.color" [matTooltip]="btn.label" (click)="click(btn.id)">
      <i class="material-icons">{{btn.icon}}</i>
    </button>
  </div>
</div>